var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUser(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "30px",
    viewBox: "0 0 24 30",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Settings&amp;Information/Account/32") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Express-Interest-flow-V2-Final-Desktop",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "1.-EI---Overview",
    transform: "translate(-453.000000, -815.000000)",
    fill: "#00095B"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Settings&Information/Account/32",
    transform: "translate(453.000000, 815.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.6002419,27.6926298 L21.6002419,24.2315744 C21.6002419,21.0496364 18.9077714,18.4608228 15.6008467,18.4608228 L8.40157242,18.4608228 C5.09222861,18.4608228 2.39975809,21.0496364 2.39975809,24.2315744 L2.39975809,27.6926298 L21.6002419,27.6926298 Z M24,30 L0,30 L0,24.2292484 C0,19.7703484 3.76171757,16.1557785 8.39915331,16.1557785 L15.6008467,16.1557785 C20.2407015,16.1557785 24,19.7703484 24,24.2292484 L24,30 Z M11.9992743,11.5391772 C9.35276686,11.5391772 7.19975809,9.46905674 7.19975809,6.92443673 C7.19975809,4.37749073 9.35276686,2.30737025 11.9992743,2.30737025 C14.6482008,2.30737025 16.8012096,4.37749073 16.8012096,6.92443673 C16.8012096,9.46905674 14.6482008,11.5391772 11.9992743,11.5391772 M11.9992743,13.8465475 C15.9787118,13.8465475 19.2009676,10.7483447 19.2009676,6.92443673 C19.2009676,3.10052877 15.9787118,0 11.9992743,0 C8.02225582,0 4.79758089,3.10052877 4.79758089,6.92443673 C4.79758089,10.7483447 8.02225582,13.8465475 11.9992743,13.8465475",
    id: "PersonalProfiles"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUser);
export default __webpack_public_path__ + "static/media/User.cbf80d2c371c6ebb174020b7ba1b2385.svg";
export { ForwardRef as ReactComponent };